module.exports = __webpack_public_path__ + "img/nicetohave-product-design-02.0cdc66c7.jpg";